<template>
  <div class="home ">
    <div class="bg1">
      <div class=" pt-44 flex flex-j-sb" style="width:960px;margin:0 auto"><div><img class="h-28 mr-10" src="@/assets/home/logo@2x.png" alt=""><img class="h-22" src="@/assets/home/slogo@2x.png" alt=""></div>
        <div class="f-c-white" />
      </div>
      <div class="setion h-408 a-normal mt-24">

        <div>

          <div class="fs-32 mt-60 f-c-white ">让每个企业都有自己的寄件平台</div>
          <div class="fs-14 fslh-28 f-c-white  mt-10">
            · 企业多员工统一在线寄件、统一结算管理<br>
            · 个人用户在线寄包裹，退货寄件和跟踪管理<br>
            · 支持顺丰、京东、邮政、申通、韵达等常用快递<br>
            · 支持预存/线下/月结等多种结算方式
          </div>
          <div>
            <!-- <img class="h-270" src="@/assets/main/s1@2x.png" alt=""> -->
          </div>
        </div>

        <div v-if="$store.state.user.company" class="bg-w t-center h-268 w-340">
          <div class="mt-40 "><img class="h-80" src="@/assets/main/avatar@2x.png" alt=""></div>
          <div class="mt-20 fs-16 fs-b ">Hi! 欢迎来到企业寄件</div>
          <div class="mt-10">
            {{ $store.state.user.company }}
          </div>
          <div v-if="!$store.state.user.company" class="mt-20 "><a-button type="primary" class="mr-20" @click="$login.show('/#/main/index')">请登录</a-button><a-button @click="$register.show('/#/main/index')">免费注册</a-button></div>
          <div v-else class="pointer f-c-blue spbtn mt-20" @click="$router.push('/main')"><a-button type="primary">进入我的企业寄件</a-button></div>
        </div>
        <!-- -->
        <div v-else class="bg-w t-center h-268 w-340">
          <div class="mt-20 fs-16 fs-b ">Hi! 欢迎来到企业寄件</div>
          <div>
            <div class="cus-button mt-23" @click="$login.show('/#/main/index')">手机号/账号登录</div>
          </div>
          <div>
            <div class="cus-button mt-15" @click="toWxWork(1)"> <img class="w-24 mr-2" src="@/assets/home/qywclogo@2x.png" alt=""> 企业微信登录</div>
          </div>
          <a-button type="primary" class="w-240 mt-15" @click="reg">
            注册新账号
          </a-button>
          <div class="fs-14 f-c-b3 mt-15">
            新用户可领取200元运费券
          </div>
        </div>

      </div>
    </div>
    <div class="setion2 ">
      <div>
        <div class="fs-16 f-c-b2 t-center mb-24">如何在企业微信中使用企业寄件？</div>
        <div class="flex">
          <div class="mr-72 h-210">
            <div class="fs-20 fs-b t-center">没有安装企业微信？</div>
            <div class="fs-12 f-c-b2 mt-4 mb-10 t-center f-c-b3">立即注册后自带“快递鸟企业寄件”的企业微信</div>
            <div class="t-center"><img class="w-80" src="@/assets/home/qywxblogo@2x.png" alt=""></div>
            <div class="cus-button1 mt-20" @click="toWxWork(2)"> <img class="w-24" src="@/assets/home/qywclogo@2x.png" alt=""> 注册企业微信(包含寄件)</div>
          </div>
          <div class="h-210">
            <div class="fs-20 fs-b t-center">通过企业微信添加使用</div>
            <div class="fs-12 f-c-b2 mt-4 mb-10 t-center f-c-b3">企业微信扫码 >  添加到应用 > 使用服务</div>
            <div class="t-center"><img class="w-80" src="@/assets/home/qrcode_50cm.png" alt=""></div>
            <div class="cus-button1 mt-20" @click="toWxWork(3)"> <img class="w-24" src="@/assets/home/qywclogo@2x.png" alt=""> 安装到企业微信</div>
          </div>
        </div>
      </div>
      <div class="h-line" />
      <div>
        <div class="t-center creat-acc h-240">
          <div>
            <div class="fs-16 f-c-b2 ">如何直接使用企业寄件？</div>
            <div class="mt-24 fs-20 fs-b ">1分钟创建新账号</div>
            <div class="fs-12 f-c-b2 mt-4 mb-10 f-c-b3">注册后可通过http://b.kdniao.com登录使用</div>
          </div>
          <div>
            <a-input v-model="phone" class="w-200 m-center" placeholder="请输入手机号" @input="errTips = ''" />
            <div v-if="errTips" class="w-200 m-center fs-12 f-c-red t-left">{{ errTips }}</div>
            <div class="cus-button1 mt-20" @click="showLogin">
              免费注册新账号
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg3">
      <div class="setion">
        <div>
          <div class="fs-40">
            员工对公寄件更方便
          </div>
          <div class="mt-20">
            多家快递公司一键下单<br>
            不用花时间找多个快递公司APP下单<br>
            支持顺丰/京东/EMS/申通等多家快递公司<br>
            自动保存收寄信息，免手动录入寄件
          </div>
        </div>
        <div>
          <img class="h-240" src="@/assets/main/img1@2x.png" alt="">
        </div>
      </div>
    </div>
    <div class="">
      <div class="setion">
        <div>
          <img class="h-240" src="@/assets/main/img2@2x.png" alt="">
        </div>
        <div>
          <div class="fs-40">
            行政前台一次性批量寄件
          </div>
          <div class="mt-20 t-right">
            多个收件客户批量下单<br>
            寄合同、寄样品更方便更快捷<br>
            在线下单实时反馈，预约快递员上门揽件<br>
            手动录入/批量导入/多条寄件等灵活寄件方式
          </div>
        </div>
      </div>
    </div>
    <div class="bg3">
      <div class="setion">
        <div>
          <div class="fs-40">
            财务统一管理与报销
          </div>
          <div class="mt-20">
            支持按部门按快递公司的统计与对账<br>
            可倒出客户信息进行存档分析<br>
            统一预存运费统一结算<br>
            支持签回单、保价等增值服务
          </div>
        </div>
        <div>
          <img class="h-240" src="@/assets/main/img3@2x.png" alt="">
        </div>
      </div>
    </div>
    <div class="">
      <div class="setion">
        <div>
          <img class="h-240" src="@/assets/main/img4@2x.png" alt="">
        </div>
        <div>
          <div class="fs-40">
            企业更高效的管理寄件
          </div>
          <div class="mt-20 t-right">
            企业统一配置快递管理和集中对账管理，提效率<br>
            多部门多员工一起寄件，集中<br>
            多种结算方式灵活操作，省时<br>
            多种场景寄件均可满足，易用
          </div>
        </div>
      </div>
    </div>
    <div class="bg3">
      <div class="m-center" style="width:1200px;height:400px">
        <div class="fs-34 t-center pt-60">适用场景</div>
        <div class="mt-40 flex a-center flex-j-sb">
          <div class="flex a-center ml-100 ">
            <img class="w-40" src="@/assets/main/01@2x.png" alt="">
            <div class="ml-20">
              <div class="fs-20 fs-b">公司寄件</div>
              <div class="mt-10">公司和员工统一寄合同文件发票、寄礼品、寄样品</div>
            </div>
          </div>
          <div class="flex a-center mr-100 w-310">
            <img class="w-40" src="@/assets/main/02@2x.png" alt="">
            <div class="ml-20">
              <div class="fs-20 fs-b">私人寄件</div>
              <div class="mt-10">个人寄物品、退换货寄件</div>
            </div>
          </div>
        </div>
        <div class="mt-40 flex a-center flex-j-sb">
          <div class="flex a-center ml-100 ">
            <img class="w-40" src="@/assets/main/03@2x.png" alt="">
            <div class="ml-20">
              <div class="fs-20 fs-b">分部门寄件</div>
              <div class="mt-10">可分部门/员工子账号独立在线寄件</div>
            </div>
          </div>
          <div class="flex a-center mr-100 w-310">
            <img class="w-40" src="@/assets/main/04@2x.png" alt="">
            <div class="ml-20">
              <div class="fs-20 fs-b">多场景寄件</div>
              <div class="mt-10">满足企业、仓库、工厂等多场景寄件</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="" style="height:400px">
      <div class="fs-34 t-center pt-60 mb-40">服务保障</div>
      <div class="flex a-center j-center">
        <div class="w-176 mr-20">
          <div>
            <img class="w-176" src="@/assets/main/s7-1.png" alt="">
          </div>
          <div class="t-center h-72 fslh-72 bg-w">
            及时上门揽件
          </div>
        </div>
        <div class="w-176 mr-20">
          <div>
            <img class="w-176" src="@/assets/main/s7-2.png" alt="">
          </div>
          <div class="t-center h-72 fslh-72 bg-w">
            智能匹配最优快递
          </div>
        </div>
        <div class="w-176 mr-20">
          <div>
            <img class="w-176" src="@/assets/main/s7-3.png" alt="">
          </div>
          <div class="t-center h-72 fslh-72 bg-w">
            在线投诉管理
          </div>
        </div>
        <div class="w-176 mr-20">
          <div>
            <img class="w-176" src="@/assets/main/s7-4.png" alt="">
          </div>
          <div class="t-center h-72 fslh-72 bg-w">
            延误丢件必赔
          </div>
        </div>
        <div class="w-176 ">
          <div>
            <img class="w-176" src="@/assets/main/s7-5.png" alt="">
          </div>
          <div class="t-center h-72 fslh-72 bg-w">
            7X12服务保障
          </div>
        </div>
      </div>
    </div>
    <div class="bg3" style="height:400px">
      <div class="fs-34 t-center pt-60 mb-40">使用流程</div>
      <div class="flex a-center j-center">
        <img style="width:960px" src="@/assets/main/s8@2x.png" alt="">
      </div>
    </div>
    <div class="bg4" style="height:400px">
      <div class="fs-34 f-c-white t-center pt-98 mb-20">使用流程</div>
      <div class="fs-24 f-c-white t-center mb-10">管理员注册设置，全员立即使用，3万多家中小微企业的选择</div>
      <div class="fs-12 f-c-white t-center mb-30">服务咨询：400-9633-321  QQ群：1104611646</div>
      <div class="t-center"> <a-button class="w-280" style="cu" @click="$store.state.user.company?$router.push('/main'):$login.show()">立即使用</a-button></div>
    </div>
    <div class="footer pt-5 pb-5">
      <div>
        <span class="mr-20"> Powererd By <img style="cursor: pointer;" class="h-14 mr-20" src="@/assets/home/qyjjlogo@2x.png" alt="" @click="showT = true"></span>
      </div>
      <div class="fs-b mt-5">
        由深圳市快金数据技术服务有限公司 提供技术支持 © 2015-2020
      </div>
    </div>
    <Tips2 :viz.sync="showT" />
  </div>
</template>
<script>
import Tips2 from '@/components/tips2'
import validate from '@framework/utils/biz-validate'
import { login } from './api'

export default {
  components: {
    Tips2
  },
  data() {
    return {
      showT: false,
      phone: '',
      errTips: false
    }
  },
  async created() {
    if (this.$getToken()) {
      await this.$store.dispatch('user/getInfo')
    }
  },
  methods: {
    async showLogin() {
      if (validate.mobile.pattern.test(this.phone)) {
        this.$register.form1.mobilePhone = this.phone
        this.$register.disabled = true
        this.$register.show('/#/main/index')
      } else {
        this.errTips = validate.mobile.msg
      }
    },
    reg() {
      this.$register.show('/#/main/index')
    },
    async toWxWork(type) {
      //  type (string): 类型（1-企业微信登录跳转，2-注册企业微信跳转，3-安装企业微信跳转）
      const res = await this.$http(this.$api.wxGetRedirectUrl, {
        type: type
      })
      if (type === 1) {
        window.location.href = res
      } else if (type === 2 || type === 3) {
        window.open(res)
      }
      //
    }

  }
}
</script>
<style lang="scss">
.home{
  .footer{
    height: 44px;
    color: #000;
    font-size: 12px;
    background: rgba(0,0,0,0.04);
    text-align: center;
  }
  .h-line{
    height: 232px;
    width: 1px;
    background: rgba(217, 217, 217, 1);
    margin-left: 72px;
    margin-right: 72px;

  }
  .setion2{
    padding-top: 50px;
    height: 340px;
    display: flex;
    align-items: flex-start;
    width: 960px;
    margin: 0 auto;
    justify-content: space-between;
  }
  .cus-button1{
       margin: 0 auto;
      width:200px;
      height:32px;
      line-height: 32px;
      font-size: 14px;
      color: rgba(47,125,205,1);
      background:rgba(255,255,255,1);
      border-radius:2px;
      border:1px solid rgba(47,125,205,1);
      text-align: center;
      cursor: pointer;
  }
  .cus-button{
    cursor: pointer;
      margin: 0 auto;
      width:240px;
      height:40px;
      line-height: 40px;
      font-size: 16px;
      color: rgba(47,125,205,1);
      background:rgba(255,255,255,1);
      border-radius:2px;
      border:1px solid rgba(47,125,205,1);
      text-align: center;
  }
  .spbtn{
    border-radius: 4px;;
    width: 200px;
    margin: 0 auto;
  }
    .bg1{
      background-image: url('~@/assets/home/banner@2x.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;;
        // background: #100831
    }
    .bg2{
        background: #f0f2f5
    }
    .bg3{
        background: #f0f5ff
    }
    .bg4{
        background: #4573E4;
    }
    .setion{
        height: 400px;
        display: flex;
        align-items: center;
        width: 960px;
        margin: 0 auto;
        justify-content: space-between;
    }
    .a-normal{
      align-items: normal;
    }
    .creat-acc{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
}

</style>
